export const STATUS_LABELS = {
  new: '新建',
  open: '处理中',
  pending: '等待回复',
  hold: '暂停',
  solved: '已解决',
  closed: '已关闭',
};

export const PRIORITY_LABELS = {
  low: '低',
  normal: '普通',
  high: '高',
  urgent: '紧急',
};

const CLOSED = new Set(['closed', 'solved']);

export const isClosed = (ticket) => ticket && CLOSED.has(ticket.status);

export const statusText = (s) => STATUS_LABELS[s] || s;
export const priorityText = (p) => PRIORITY_LABELS[p] || p || '普通';

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getQueryParam = (key) => new URLSearchParams(window.location.search).get(key);
